<template>
  <div class="asd-form">
    <div class="asd-form-section">
      <div class="section-title">
        <h5>
          <i class="fas fa-plus-square"></i>
          Nový ukol
        </h5>
        <div class="section-title-controls">
          <ActiveButton v-if="taskId !== null"
                        v-help.mouse="`Vytvořit podúkol`"
                        class="asd-btn-confirm"
                        :click="subtask"
                        :disabled="step < 2"
          >
            <i class="fas fa-indent"></i>
          </ActiveButton>
          <ActiveButton v-if="taskId !== null"
                        v-help.mouse="`Uložit`"
                        class="asd-btn-confirm"
                        :click="save"
                        :disabled="step < 2"
          >
            <i class="fas fa-save"></i>
          </ActiveButton>
          <ActiveButton v-if="taskId === null"
                        v-help.mouse="`Vytvořit nový úkol`"
                        class="asd-btn-confirm"
                        :click="create"
                        :disabled="step < 2"
          >
            <i class="fas fa-save"></i>
          </ActiveButton>
        </div>
      </div>
      <label>Projekt</label>
      <Multiselect
        v-model="data.project.id"
        label="label"
        trackBy="id"
        valueByPath="id"
        :returnAsSingle="true"
        :options="projects"
        :allowEmpty="false"
        :disabled="projectDisabled"
        :max="1"
      ></Multiselect>
      <label v-if="step >= 1">Typ úkolu</label>
      <Multiselect
        v-if="step >= 1"
        v-model="data.taskType.id"
        label="name"
        trackBy="id"
        valueByPath="id"
        :returnAsSingle="true"
        :options="taskTypes"
        :allowEmpty="false"
        :max="1"
      ></Multiselect>
      <PropertyForm
        v-if="step >= 2"
        v-model="data.propertyValues"
        :propertyKeys="taskPropertyKeys"
        :meta="{parentTask, project, entityType: taskType}"
        editType="new"
      ></PropertyForm>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import PropertyForm from 'CORE/components/form/property-form'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import labels from 'CORE/utils/labels'
import ActiveButton from 'CORE/components/form/active-button'
import Vue from 'vue'
import EventBus from 'CORE/bus'

export default {
    name: 'TaskForm',
    components: {
        PropertyForm,
        Multiselect,
        ActiveButton,
    },
    props: {
        taskId: {
            type: String,
            required: false,
            default: _ => null,
        },
        preselectedProjectId: {
            type: String,
            required: false,
            default: _ => null,
        },
        parentTask: {
            type: String,
            required: false,
            default: _ => null,
        },
    },
    data: function() {
        return {
            data: {},
        }
    },
    computed: {
        projects() {
            return _.map(this.$store.getters.projects, p => {
                return {
                    id: p.id,
                    label: labels.project(p),
                }
            })
        },
        taskTypes() {
            return this.$store.getters.taskTypes
        },
        taskPropertyKeys() {
            const taskType = this.$store.getters.taskTypeById(_.get(this.data, 'taskType.id'))
            return _.map(_.get(taskType, 'propertyType', []), pt => _.get(pt, 'key'))
        },
        step() {
            if (_.isString(_.get(this.data, 'taskType.id'))) return 2
            if (_.isString(_.get(this.data, 'project.id'))) return 1
            return 0
        },
        projectDisabled() {
            if (this.preselectedProjectId !== null) return true
            if (this.parentTask !== null) return true
            return false
        },
        project() {
            const projectId = _.get(this.data, 'project.id', null)
            return this.$store.getters.getProjectById(projectId)
        },
        taskType() {
            return this.$store.getters.taskTypeById(_.get(this.data, 'taskType.id'))
        },
        DLI() {
            return this.$store.getters.DLI
        },
    },
    watch: {
        DLI() {
            if (this.taskId !== null) {
                const newData = this.$store.getters.taskById(this.taskId)
                if (newData) {
                    this.data = newData
                }
            }
        }
    },
    created() {
        if (this.taskId === null) {
            let projectId = null
            if (this.preselectedProjectId !== null) {
                projectId = this.preselectedProjectId
            }
            if (this.parentTask !== null) {
                const parentTask = this.$store.getters.taskById(this.parentTask)
                projectId = _.get(parentTask, 'project.id', null)
            }
            Vue.set(this.data, 'id', this.$uuid.v4())
            Vue.set(this.data, 'taskType', { id: null })
            Vue.set(this.data, 'project', { id: projectId })
            Vue.set(this.data, 'settings', {})
            Vue.set(this.data, 'propertyValues', {})
        } else {
            this.data = this.$store.getters.taskById(this.taskId)
        }
        console.assert(
            _.isString(_.get(this.data, 'id')),
            'Invalid ID after data creation (not existing Task or invalid UUID creation)'
        )
    },
    methods: {
        async save() {
            try {
                await this.$store.dispatch('updateTask', this.data)
                await this.$store.dispatch('tasksLoad')
                EventBus.$emit('PUBLISH_UPDATE', { entity_type: 'task', entity_id: this.data.id })
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.$emit('done')
            } catch (e) {
                this.data = this.$store.getters.taskById(this.taskId)
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
        async create() {
            try {
                await this.$store.dispatch('createTask', this.data)
                await this.$store.dispatch('tasksLoad')
                EventBus.$emit('PUBLISH_UPDATE', { entity_type: 'task', entity_id: this.data.id })
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
        async subtask() {
            this.$router.push({
                name: 'tasksNew',
                query: {
                    parentTask: this.data.id,
                    backProjectId: this.$route.query.backProjectId ? this.$route.query.backProjectId : undefined,
                },
            })
        },
    },
}
</script>
